
import React, { useEffect, useState } from 'react';
import './styles.css';
import { MdSend } from "react-icons/md";
import CloseIcon from '@mui/icons-material/Close';

// TODO: Still working on this //

var chat = [];
const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [forceRerender, setForceRerender] = useState(true);
  const [text, setText] = useState('');
  const [chatArray, setChatArray] = useState([
    {
      name: 'UWP',
      message: 'WELCOME',
    },
  ]);

  const handleSubmit = () => {

    var chatSchema = {
      name: 'User',
      message: text,
    };

    chat.push(chatSchema);

    const body = {
      text: text
    };
    console.log('body: ', body);


    fetch('http://127.0.0.1:7000/sendChat', {
      method: 'POST',
      body: JSON.stringify(body),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        return response.json()
      })
      .then(r => {
        console.log(r);
        let resposeSchema = { name: 'UWP', message: r.result };
        chat.push(resposeSchema);
        setChatArray([...chat]);
        setText('')
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  return (
    <div class="container" style={{ position: 'fixed', zIndex: '1', bottom: '0%', right: "1%", width: "20%", }}>
      <div  >
        <div
          class="chatbox__support"
          style={
            !open
              ? {
                display: 'none',
                flexDirection: 'column',
                background: '#eee',
                width: '300px',
                height: '350px',
                zIndex: '-123456',
                transition: 'all .5s ease-in-out',

              }
              : {
                display: 'flex',
                flexDirection: 'column',
                transform: 'translateY(-40px)',
                background: '#eee',
                width: '350px',
                height: '450px',
                zIndex: '123456',
                opacity: '1',
                transition: 'all .5s ease-in-out',
                marginBottom: '5vh',
                marginLeft: '-5vw'
              }
          }
        >
          <div class="chatbox__header">
           
           
              <h4 class="chatbox__heading--header"> Chatbot</h4>
             <a onClick={() => setOpen(!open)}  style={{color:"#fff"}}>
                 <CloseIcon></CloseIcon>
             </a>
            
          </div>
          <div class="chatbox__messages">

            {chat
              .slice()
              .reverse()

              .map(chats =>

                chats.name === 'UWP' ? (
                  <div class="messages__item messages__item--visitor">{chats.message}</div>
                ) : (
                  <div class="messages__item messages__item--operator">{chats.message}</div>
                ),
              )}
          </div>
          <div class="chatbox__footer">
            <input type="text" placeholder="Write a message..." value={text} onChange={e => setText(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSubmit()} />
            <button class="chatbox__send--footer send__button" onClick={handleSubmit}  >
              <MdSend></MdSend>
            </button>
          </div>
        </div>
        <div class="chatbox__button">
          <button onClick={() => setOpen(!open)}>
            <img src="https://img.icons8.com/color/48/000000/online-support.png" />
          </button>
        </div>
      </div>
    </div >
  




  );
};

export default ChatBot;
